import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../../../../../core/service/base/his-base-globals.service';
import { resourcePropertyMap } from '../../../model/his-resource-property-display.model';
import { ResourcePropertyDetail } from '../../../model/resource-property-detail.model';

/**
 * Marks a file that carries a data source with the name of that data source.
 *
 * This is the Angular counterpart of the {@code dataSource} fragment of the JSF
 * {@code selectFile-metadata-icon.xhtml}.
 */
@Component( {
    standalone: false,
    selector: 'his-data-source-icon',
    templateUrl: './his-data-source-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './his-data-source-icon.component.css',
} )
export class HisDataSourceIconComponent {

    /** The properties of the {@code dataSource} category of the file. */
    readonly details = input.required<ResourcePropertyDetail[]>();

    private readonly globals = inject( HisBaseGlobalsService );

    protected readonly walletBackground = computed( () => {
        const image = this.globals.getImage( 'WALLET' );
        return image ? `url('/HISinOne/images/${image}')` : 'none';
    } );

    /** The type of the data source, or `undefined` while it is not known. */
    protected readonly type = computed<string | undefined>( () =>
        resourcePropertyMap( this.details() ).get( 'type' ) || undefined
    );

    protected readonly contentDescription = computed( () =>
        resourcePropertyMap( this.details() ).get( 'contentDescription' ) || ''
    );
}
